import type { SignOutEvent } from "../state-machines/sign-out-machine";

/**
 * Actions required by the profile handlers.
 * Decouples the hook from specific implementations of auth, storage and routing.
 /** Waits for the app to finish booting (skeleton overlay disappears). */
export interface ProfileActions {
  signOut: () => Promise<void>;
  onSignOutSuccess: () => void;
  revokeSession: (sessionId: string) => Promise<void>;
}

/**
 * Agnostic handlers for Profile and Sign Out interactions.
 /** Waits for the app to finish booting (skeleton overlay disappears). */
export function createProfileHandlers(send: (event: SignOutEvent) => void) {
  return {
    promptSignOut: () => {
      send({ type: "SIGN_OUT_REQUESTED" });
    },
    promptQuickSignOut: () => {
      send({ type: "LOGOUT_QUICK_REQUESTED" });
    },
    promptClearData: () => {
      send({ type: "CLEAR_DATA_REQUESTED" });
    },
    promptRevokeSession: (sessionId: string) => {
      send({ type: "REVOKE_REQUESTED", sessionId });
    },
    doSignOut: (options?: { force?: boolean }) => {
      if (options?.force) {
        send({ type: "FORCE_LOGOUT_REQUESTED" });
      } else {
        send({ type: "SIGN_OUT_REQUESTED" });
      }
    },
    doClearLocalData: () => {
      send({ type: "CLEAR_DATA_REQUESTED" });
    },
    doRevokeSession: (sessionId: string) => {
      send({ type: "REVOKE_REQUESTED", sessionId });
    },
  };
}
